import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

// Check if running in local environment
const isLocalEnvironment = environment.config?.apiUrl?.includes('localhost');

// Disable console in all environments except local
if (environment.production) {
  enableProdMode();
}

if (!isLocalEnvironment && window && window.console) {
  window.console.log = function() {};
  window.console.warn = function() {};
  window.console.info = function() {};
  window.console.debug = function() {};
  window.console.error = function() {};

  // Keep console.error for critical errors
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
